/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IntegrationsControllerListIntegrationsQueryResponse, IntegrationsControllerListIntegrationsPathParams } from "../../models/integrationsController/IntegrationsControllerListIntegrations";

function getIntegrationsControllerListIntegrationsUrl(scopeId: IntegrationsControllerListIntegrationsPathParams["scopeId"]) {
  const res = { method: 'GET', url: `/api/v1/integrations/${scopeId}` as const }  
  return res
}

/**
 * @summary List available providers and connected user integrations
 * {@link /api/v1/integrations/:scopeId}
 * @deprecated
 */
export async function integrationsControllerListIntegrations(scopeId: IntegrationsControllerListIntegrationsPathParams["scopeId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IntegrationsControllerListIntegrationsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getIntegrationsControllerListIntegrationsUrl(scopeId).url.toString(), ... requestConfig })  
  return res.data
}